module.exports = __webpack_public_path__ + "static/media/venec2.22074f72.jpg";